import request from '@/sheep/request';

// 愿望评论
export interface WishesMessage {
	userId ?: number
	wishId ?: number
	parentId ?: number
	nickname ?: string
	content ?: string
	avatar ?: string
	likeCount ?: number
	toUserId ?: number
	toNickname ?: string
	isReport ?: boolean
	reason ?: string
}

// 创建愿望评论
export const createWishesMessage = async (data : Partial<WishesMessage>) => {
	return request({
		url: '/wish/wishes/message/publish',
		method: 'POST',
		data,
		custom: {
			auth: true,
			showLoading: false,
		}
	});
}

// 获取愿望评论列表 分页
export const getWishesMessagePage = async (params ?: any) => {
	return request({
		url: '/wish/wishes/message/page-root',
		method: 'GET',
		params
	});
}

// 获取愿望评论回复列表 分页
export const getWishesMessageRepliesPage = async (params ?: any) => {
	return request({
		url: '/wish/wishes/message/page-replies',
		method: 'GET',
		params
	});
}

// 获取愿望评论列表
export const getWishesMessageList = async (params ?: any) => {
	return request({
		url: '/wish/wishes/message/list',
		method: 'GET',
		params
	});
}

// 评论点赞
export const likeWishMessage = async (params : any) => {
	return request({
		url: '/wish/wishes/message/like',
		method: 'GET',
		params: params,
		custom: {
			auth: true,
			showLoading: false,
		}
	});
}

// 删除愿望评论
export const deleteWishesMessage = async (id ?: number) => {
	return request({
		url: '/wish/wishes/message/delete/' + id,
		method: 'GET',
	});
}